import { apiAxiosCMS } from 'services/api';

export async function deleteItemFromBd(id: string, handleNotify: any) {
	let resp = false;
	await apiAxiosCMS
		.delete(`/menu-items/${id}`)
		.then(() => {
			resp = true;
			handleNotify('Item deletado com sucesso', 'success');
		})
		.catch((error) => {
			resp = false;
			handleNotify(error?.message || 'Erro ao deletar o item', 'error');
		});

	return resp;
}
